export enum GracePeriodPoint {
  Present = 1,
  Today = 2,
}

export enum GracePeriodUnit {
  Minute = 1,
  Day = 2,
}
